export const INFO_BUBBLE_GET_MARKER_DETAILS = "INFO_BUBBLE_GET_MARKER_DETAILS";
export const INFO_BUBBLE_GET_MARKER_DETAILS_RESPONSE = "INFO_BUBBLE_GET_MARKER_DETAILS_RESPONSE";
export const INFO_BUBBLE_GET_LAST_SNAPSHOT = "INFO_BUBBLE_GET_LAST_SNAPSHOT";
export const INFO_BUBBLE_GET_LAST_SNAPSHOT_RESPONSE = "INFO_BUBBLE_GET_LAST_SNAPSHOT_RESPONSE";
export const INFO_BUBBLE_SHOW_TIMELINE = "INFO_BUBBLE_SHOW_TIMELINE";
export const INFO_BUBBLE_CLIP_REQUEST_DATE = "INFO_BUBBLE_CLIP_REQUEST_DATE";
export const INFO_BUBBLE_GET_PUBLIC_MARKER_DETAILS = "INFO_BUBBLE_GET_PUBLIC_MARKER_DETAILS";
export const INFO_BUBBLE_GET_VEHICLELIST_GET_ID = "INFO_BUBBLE_GET_VEHICLELIST_GET_ID";